(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"), require("FEGOBridge"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender", "FEGOBridge"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/marquee-text/render"] = factory(require("FEGORender"), require("FEGOBridge"));
	else
		root["/fego/component/marquee-text/render"] = factory(root["FEGORender"], root["FEGOBridge"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__7145__) {
return 